/* eslint-disable no-restricted-syntax */
import { ISpaceRoute } from '@/types';

export function removeChildById(
  route: ISpaceRoute,
  pageId: string,
): ISpaceRoute {
  const newRoute = { ...route };

  // Base case: if obj has no children, return obj
  if ((newRoute.children_keys || []).length === 0) {
    return newRoute;
  }

  // Check if any of the children have the given page_id
  const index = (newRoute.children_keys || []).findIndex(
    (key) => newRoute.children[key].page_id === pageId,
  );

  // If the page_id was found, remove the child
  if (index !== -1) {
    const key = (newRoute.children_keys || []).splice(
      index,
      1,
    )[0];
    delete newRoute.children[key];
    return newRoute;
  }

  // Recursively remove the child from the children
  for (const key of newRoute.children_keys || []) {
    if (!newRoute.children) {
      newRoute.children = {};
    }
    newRoute.children[key] = removeChildById(
      newRoute.children[key],
      pageId,
    );
  }

  return newRoute;
}
